import { useCallback, useState } from "react";

export const useReferencedItems = () => {
  const [referencedItems, setReferencedItems] = useState([]);

  // Add a referenced item
  const addReferencedItem = useCallback((item) => {
    setReferencedItems((prev) => {
      // Avoid duplicates
      const exists = prev.some((existing) => existing.id === item.id);
      if (exists) return prev;

      return [...prev, item];
    });
  }, []);

  // Remove a referenced item
  const removeReferencedItem = useCallback((itemId) => {
    setReferencedItems((prev) => prev.filter((item) => item.id !== itemId));
  }, []);

  // Clear all referenced items
  const clearReferencedItems = useCallback(() => {
    setReferencedItems([]);
  }, []);

  return {
    referencedItems,
    setReferencedItems,
    addReferencedItem,
    removeReferencedItem,
    clearReferencedItems,
  };
};
